import React from "react";
import "./Sidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FiBox, FiExternalLink, FiGrid, FiLogOut, FiShoppingBag } from "react-icons/fi";
import * as backendModule from "../../modules/backendModule";
import { useDispatch } from "react-redux";
import * as timestampActions from "../../actions/timestampActions";
import animateModule from "../../modules/animateModule";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const animateNavigate = (to) => {
    if (location.pathname === to) return;
    animateModule(navigate, to, document.querySelector(".route__toAnimate"));
  };

  const logout = () => {
    axios({ method: "GET", url: `${backendModule.backendURL}/auth/logout`, ...backendModule.axiosConfig })
      .then(() => {
        dispatch(timestampActions.updateTimestamp());
        animateNavigate("/");
      })
      .catch(() => {});
  };

  const links = [
    { to: "/admin/dashboard", label: "Nadzorna ploča", icon: FiGrid },
    { to: "/admin/products", label: "Proizvodi", icon: FiBox },
    { to: "/admin/orders", label: "Narudžbe", icon: FiShoppingBag },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <span className="sidebar__brand-mark">AF</span>
        <div><strong>Alpha Focus</strong><small>Administracija</small></div>
      </div>
      <nav className="sidebar__content">
        <span className="sidebar__label">UPRAVLJANJE</span>
        {links.map(({ to, label, icon: Icon }) => (
          <Link key={to} to={to} className={location.pathname.includes(to.split("/").pop()) ? "sidebar__link sidebar__link--active" : "sidebar__link"}>
            <Icon /><span>{label}</span>
          </Link>
        ))}
        <div className="sidebar__spacer" />
        <Link to="/" className="sidebar__link"><FiExternalLink /><span>Nazad na shop</span></Link>
        <button type="button" onClick={logout} className="sidebar__link sidebar__logout"><FiLogOut /><span>Odjavi se</span></button>
      </nav>
    </aside>
  );
};

export default Sidebar;
